<template>
    <div v-if="showReportDashboard" class="reports-dashboard">
        <header class="reports-dashboard__header">
            <div class="reports-dashboard__nav-title">
                <CompassTooltip
                    :content="$t.__('common.actions.back')"
                    placement="bottom-start"
                    :arrow="false"
                >
                    <CompassIconButton icon="caret-left" @click="handleGoBackToListingReports" />
                </CompassTooltip>
                <h1 class="typographies-heading-h1 reports-dashboard__title-h3">
                    {{ report.name }}
                </h1>
                <CompassTooltip :content="contentTooltipFavorite" :arrow="false">
                    <CompassIconButton
                        :icon="isFavorite ? 'star-fill' : 'star'"
                        :class="classesFavIcon"
                        :disabled="loadingBtnFavorite"
                        @click.stop="toggleFavorite"
                    />
                </CompassTooltip>
                <CompassTag v-if="showCategory" :color="getColorTag">
                    {{ getLabelCategory }}
                </CompassTag>
            </div>
            <p class="typographies-paragraph-medium-regular reports-dashboard__subtitle">
                {{ report.description }}
            </p>
        </header>

        <LuzmoDashboard
            ref="dashboardInstance"
            :dashboardId="report.id"
            switchScreenModeOnResize
            :authKey="auth.key"
            :authToken="auth.token"
        />
    </div>
</template>

<script>
import ReportsApi from 'api/reports/reports';
import reportsMixins from 'mixins/reports/reportsMixins.js';
import { LuzmoDashboard } from '@luzmo/vue-embed';

export default {
    components: { LuzmoDashboard },
    mixins: [reportsMixins],
    data() {
        return {
            report: null,
            auth: null,
        };
    },
    computed: {
        classesFavIcon() {
            return {
                'reports-dashboard__favorite-icon': true,
                'reports-dashboard__favorite-icon--active':
                    this.isFavorite && !this.loadingBtnFavorite,
                'reports-dashboard__favorite-icon--loading': this.loadingBtnFavorite,
            };
        },
        showReportDashboard() {
            return this.report && this.auth && this.auth.token && this.auth.key;
        },
    },
    created() {
        this.getReports();
    },
    methods: {
        getReports() {
            ReportsApi.getReports()
                .then((response) => {
                    const data = response.data.data;
                    const aggregations = response.data.aggregations;

                    this.report = data.find(
                        (report) => report.dashboard_id === this.$route.params.id,
                    );
                    this.report = {
                        id: this.report.dashboard_id ?? null,
                        name: this.getReportName(this.report.name),
                        description: this.report.subtitle ?? null,
                        category: this.report.tags[0],
                        favorite: this.report.is_favorite ?? false,
                    };
                    this.auth = aggregations.cumulio || false;
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('common.labels.toast.error'),
                    });
                });
        },
        getReportName(name) {
            // No longer needed once the first deployment is done
            const parts = name.split('>');
            if (parts.length >= 3) {
                return parts[2].trim();
            }
            return name.trim();
        },
        handleGoBackToListingReports() {
            this.$router.push({ name: 'reports.listing' });
        },
        // Toggle favorite state (used on mixin)
        // eslint-disable-next-line vue/no-unused-properties
        onFavoriteToggleSuccess(newFavoriteState) {
            this.report.favorite = newFavoriteState;
        },
    },
};
</script>

<style lang="scss" scoped>
.reports-dashboard {
    &__header {
        height: var(--spacing-5);
        display: flex;
        flex-direction: column;

        margin: 0 0 var(--spacing-5) 0;
    }
    h1 {
        margin: 0;
    }

    &__nav-title {
        display: flex;
        gap: var(--spacing-1);
        align-items: center;
        margin: 0 var(--spacing-0) var(--spacing-1) 0;
    }

    &__favorite-icon {
        color: var(--colors-common-icon-fav-default);

        &--active {
            color: var(--colors-common-icon-fav-active);
        }
        &--loading {
            color: var(--colors-common-icon-fav-default);
        }
    }

    &__subtitle {
        margin: 0 0 0 36px;
        color: var(--colors-common-text-subtle-default);
    }
}
</style>
